// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewerPage_wrapper__5V6UC","page":"ViewerPage_page__-j0z6","errorWrapper":"ViewerPage_errorWrapper__QB3oK"};